<template>
	<div class="middleBox">
	 	<h4 class="title pb-3 border-bottom text-left mb-4 mobLeftpad">{{$t('declaration')}} {{languageChangeDetectFunc}}</h4> 
		<!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<Warningpop v-if="showRisk"></Warningpop>
		<div class="row" v-if="testFail">
			<div class="col-12">
				<div class="p-5 text-center">
					<div class="thumb mb-3">
						<img src="../../../../static/fxView/images/test_failed.svg" alt="Test Failed"  width="220">
					</div>
					<h3>{{$t('stepMsz6Title')}}</h3>
					<p v-html="$t('stepMsz6')"></p>
				</div>
			</div>
		</div>
		<div class="stepForm  row" v-else> 
			<!-- <div class="col-12 pr-0">
				<div class="form-group" v-if="parseInt(get_user.step) == 3">
					<h6 class="modal-title" style="color:red">Please complete registeration process first!</h6>
				</div>
			</div> -->
			<!-- <div v-if="$root.$children[0].languageChangeDetect == 'es'"> -->
				<div class="searchDec" v-if="$root.$children[0].languageChangeDetect == 'es'">
				<label >{{$t('Typebelow')}}</label>
				<input type="text" class="form-control" v-model="type_msg" name="type_msg"  v-validate="'required'" >
				<p class="error" v-if="submitted" v-for="error in errors.collect('type_msg')">{{$t('fieldReq')}}.</p>
			</div>
			
			<div class="col-12 mobPad">
				<ul class="step-4">
					<li >
						<label class="text-left fancy_radiochk_btn">{{$t('stepMsz8')}}
							<!-- <router-link to="#"> Read More</router-link> -->
							<input type="checkbox" class="form-control" v-model="check1" v-validate="'required'" name="check1"  :class="{ 'is-invalid': submitted && errors.has('check1') }" ref="check1Input"><span class="checkmark" ></span>
							<p class="error" v-if="submitted" v-for="error in errors.collect('check1')">{{$t('fieldReq1')}}.</p>  
						</label>
					</li>
					<li>
						<label class="text-left fancy_radiochk_btn">{{$t('stepMsz9')}} 

							<a href="../../../static/fxView/pdf/Client_Agreement_Jun 2025.pdf" target="_blank">{{$t('ClientAgreement')}}</a>, 
							<a href="../../../static/fxView/pdf/Client_Identification_Procedure_August_2023.pdf" target="_blank">{{$t('IdentificationProcedure')}}</a>, 
							<a href="../../../static/fxView/pdf/Best_Interest_and_Order_Execution_Policy_August_2023.pdf" target="_blank">{{$t('OrderExecutionPolicy')}}</a>, 
							<a href="../../../static/fxView/pdf/Conflict_of_Interest_Policy_August_2023.pdf" target="_blank">{{$t('ConflictofInterest')}}</a>, 
							<a href="../../../static/fxView/pdf/Client_Categorization_Policy_August_2023.pdf" target="_blank">{{$t('ClientCategorisation')}}</a>,
							<a href="../../../static/fxView/pdf/Investor_Compensation_Fund_July_2023.pdf" target="_blank">{{$t('InvestorCompensation')}}</a>, 
							<a href="https://fxview.com/legal-documents" target="_blank">{{$t('stepDisclamar_msz')}}</a>,
							<a href="../../../static/fxView/pdf/Privacy_Policy_August_2023.pdf" target="_blank">{{$t('privacyPolicy')}}</a>,
							<a href="../../../static/fxView/pdf/Cost_and_Associated_Charges_August_2023.pdf" target="_blank">{{$t('CostAssociatedCharges')}}</a>,
							<a href="../../../static/fxView/pdf/Complaints_Procedure_August_2023.pdf" target="_blank">{{$t('ComplaintProcedure')}}</a> {{$t('and')}}
							<a href="../../../static/fxView/pdf/Risk_Disclosure_and_Warnings_Notice_August_2023.pdf" target="_blank">{{$t('riskDisclaimer')}}</a>
							<input type="checkbox"  class="form-control" v-model="check2" v-validate="'required'" name="check2"  :class="{ 'is-invalid': submitted && errors.has('check2') }" ref="check2Input"><span class="checkmark"></span>
							<p class="error" v-if="submitted" v-for="error in errors.collect('check2')">{{$t('fieldReq1')}}.</p> 
						</label>
					</li>
					<li>
						<label class="text-left fancy_radiochk_btn">{{$t('stepMsz10')}}
							<input type="checkbox"  class="form-control" v-model="check3" v-validate="'required'" name="check3"  :class="{ 'is-invalid': submitted && errors.has('check3') }" ref="check3Input"><span class="checkmark"></span>
							<p class="error" v-if="submitted" v-for="error in errors.collect('check3')">{{$t('fieldReq1')}}.</p> 
						</label>
					</li>
					<li>
						<label class="text-left fancy_radiochk_btn">{{$t('stepMsz11')}}
							<input type="checkbox"  class="form-control" v-model="check4" v-validate="'required'" name="check4"  :class="{ 'is-invalid': submitted && errors.has('check4') }" ref="check4Input"><span class="checkmark"></span>
							<p class="error" v-if="submitted" v-for="error in errors.collect('check4')">{{$t('fieldReq1')}}.</p>
						</label>
					</li>
					<li v-if="$root.$children[0].languageChangeDetect == 'es'">
						<label class="text-left fancy_radiochk_btn">
							<span>{{$t('riskWarning')}} <a href="#" v-if="text == false" @click="text = !text">{{$t('SeeMor')}} </a></span>
							<span v-if="text">{{$t('Acquisition')}}<a href="#" @click="text = !text">{{$t('Seeles')}} </a></span>
							<input type="checkbox"  class="form-control" v-model="check5" v-validate="'required'" name="check5"  :class="{ 'is-invalid': submitted && errors.has('check5') }" ref="check4Input"><span class="checkmark"></span>
							<p class="error" v-if="submitted" v-for="error in errors.collect('check5')">{{$t('fieldReq1')}}.</p>
						</label>
					</li>
				</ul>
			</div>

			<div class="col-12 mobPad">
				<div class="step-bottom-alert"> 
				    <span><svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="custom-class feather feather-alert-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg></span>
				    <p>{{$t('AfterCalling')}} "{{$t('saveContinue')}}", {{$t('allInfoCorrect')}}</p>
				</div>
			</div>

			

			<div class="col-12 mobPad">
                <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
                    <div class="leftbtn">
                        <a href="#"  v-on:click="doitLater" >{{$t('iDoLater')}}</a>
                       
                    </div> 
                    <button class="prism_btn btn_sm" v-on:click="submit()">{{$t('saveContinue')}}</button>
                </div>
            </div>
			 
		</div>
	</div>
</template>
<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
	import Warningpop from '../shared/warnings-notice'
	import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'stepFour',
		mixins: [fxViewMixins],
        data() {
            return {
				"step" : 4,
				check1 : false,
				check2 : false,
				check3 : false,
				check4 : false,
				check5 : false,
				submitted : false,
				response_msg : '',
                msg_type : '',
                pageLoader : false,
                type_msg: '',
                text: false ,
                select_lang : '', 

				showRisk : false,
				testFail: false,

            }
        },
		components : {
			Warningpop
		},
        computed:{
        	languageChangeDetectFunc(){
        		if(this.$root.$children[0].languageChangeDetect != 'es'){
					this.type_msg = ''
				}
        		console.log('languageChangeDetect in step4===========',this.$root.$children[0].languageChangeDetect)
        	}
        },
		methods:{
			closeModalFunc(){
				this.$parent.$parent.showStepComponent = false
			},
			...mapActions({
                _runRegisterStepFour: types.RUN_REGISTER_STEP4
            }),
			submit(){
				
				if(this.disable){
                    let currentStep = this.get_user.step
                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = 5          
                    let user_json = this.get_user
                    this.$store.commit(SET_STATE, user_json)
                }else{
					const _that = this
					_that.submitted = true;
					_that.$validator.validate().then(valid => {
						if (valid) {
							let input_json={
								'globalParams' :{
									'terms_agreed' : 1,
									'type_msz_for_spain_user' : _that.type_msg,
									'step' : _that.step,
								},
								'localParams' :{
									"parameter" : _that
								}
							}
							this.$trackEvent('CP+Client+Verification+9+Next')
							_that._runRegisterStepFour(input_json)
						}else{
							_that.handleValidationErrorAdvanced(_that.errors)
						}
					})
				}
			},
			doitLater(){
				this.$parent.do_later = true
				this.$trackEvent('CP+Client+Verification+9+Later')
			}
		},
		created(){
			this.$trackEvent('CP+Client+Verification+9+Pageview')
			this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '4'}})

			this.select_lang = localStorage.getItem('lang')
			
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step4.vue